export const loadingImg = {
  blackLoading: require('./loading/apploader-black.gif'),
  uploading: require('./loading/uploading.gif')
};
